import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { IProduktionsmalRequest } from "./produktionsmal.models";

export class ProduktionsmalValidation {
    static init(searchFilter: IProduktionsmalRequest, minDate: Date): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.sok).withRules([
            {
                id: 1,
                errorLevel: ValidationErrorLevels.error,
                applicable: (newValue: NgbDate, oldValue: NgbDate) => ObjectUtils.hasValue(newValue),
                expression: (newValue: NgbDate) => {
                    if (ObjectUtils.isNullOrUndefined(newValue)) {
                        return false;
                    }

                    const val = typeof newValue === "string" ? moment(newValue).startOf("month").toDate() :
                        moment(new Date(newValue.year, newValue.month - 1)).startOf("month").toDate();
                    return val >= minDate;
                },
                message: { text: "Fr.o.m datum får inte vara tom eller tidigare än nuvarande månad." },
                model: () => searchFilter.periodstart,
                name: "fromDate"
            },
            {
                id: 2,
                errorLevel: ValidationErrorLevels.error,
                applicable: (newValue: NgbDate, oldValue: NgbDate) => ObjectUtils.hasValue(newValue),
                expression: (newValue: NgbDate) => {
                    if (ObjectUtils.isNullOrUndefined(newValue)) {
                        return false;
                    }

                    const val = typeof newValue === "string" ? moment(newValue).startOf("month").toDate() :
                        moment(new Date(newValue.year, newValue.month - 1)).startOf("month").toDate();
                    return val >= moment(searchFilter.periodstart).startOf("month").toDate();
                },
                message: { text: "T.o.m. datum får inte vara tom eller tidigare än Fr.o.m. datum." },
                model: () => searchFilter.periodslut,
                name: "tomDate"
            }
        ]);

        return context;
    }
}
